<template>
	<div id="content" class="content mypage">
		<div class="container">
			<!-- 페이지 타이틀 -->
			<div class="page-title">
				<h2 class="tit">구매내역</h2>
			</div>
			<div class="payment-product">
				<h3>주문상품</h3>
				<div class="product-list">
					<div class="row-box" v-for="item in producList">
						<div class="product-thumb">
							<img v-if="item.goodsVO.thumbnail !== null" :src="APIs.SHOP_FILE_SHOW + item.goodsVO.thumbIdx" alt="">
							<img v-else src="public/ssflex/assets/img/common/img_thumb.svg">
						</div>
						<div class="product-name">
							<a :href="'/app/shop/goods/'+item.goodsVO.gid">{{ item.goodsVO.title }}</a>
						</div>
						<div class="product-quantity">x{{ item.count }}</div>
						<div class="product-price">
							{{ item.payPrice | currency }} <span class="unit">원</span>
						</div>
					</div>
				</div>
			</div>
			<div class="payment-info">
				<h3 class="title">결제 정보</h3>
				<div class="gui-tbl">
					<div class="row-box">
						<div class="th">주문번호</div>
						<div class="td">{{ oid }}</div>
					</div>
					<div class="row-box">
						<div class="th">총 결제 금액</div>
						<div class="td">{{ orderInfo.orderPrice | currency }} 원</div>
					</div>
					<div class="row-box">
						<div class="th">결제방법</div>
						<div class="td">{{ paidType }}</div>
					</div>
<!--					무통장 입금 추가시 추가 작성 -->
<!--					<div class="row-box">-->
<!--						<div class="th">입금계좌</div>-->
<!--						<div class="td"><span>농협/123456789123456</span></div>-->
<!--					</div>-->
<!--					<div class="row-box">-->
<!--						<div class="th">예금주</div>-->
<!--						<div class="td">상상진화</div>-->
<!--					</div>-->
<!--					<div class="row-box">-->
<!--						<div class="th">입금기한</div>-->
<!--						<div class="td">2021.08.31</div>-->
<!--					</div>-->
				</div>
			</div>
			<div class="btn-area">
				<template v-if="orderInfo.stat === 2">
					<button type="button" id="cancelBtn" class="btn-submit" @click="doInicisCancel">주문취소</button>
				</template>
				<template v-if="orderInfo.stat === 8">
					<button type="button" id="cancelReqBtn" class="btn-submit" @click="doReqCancel">취소요청</button>
				</template>
					<button type="button" class="btn-submit" @click="goPaymentList">목록으로</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "paymentDetail",
	data() {
		var params = new this.pageUtils.Params();
		var oid = this.$route.params.oid
		params.oid = this.$route.params.oid
		params.reqStat = 65; //결제요청
		console.log("params", params)

		return {
			oid,
			orderInfo: new this.OrderInfoVO( this.getSessionProc() ),
			producList: [],
			paidType: "신용카드",
			params,
		}
	},
	async created() {
		await !this.requireLogin(this, false);
	},
	mounted() {
		this.getPaymentInfo();
	},
	methods: {
		getPaymentInfo(){
			var self = this;

			this.axiosCaller.get(this, this.APIs.SHOP_ORDER + "/getOrderInfo", {
				oid : self.oid
			}, (res) => {
				if (res.data.status === "ok") {
					this.orderInfo = res.data.orderInfo;
					this.producList = res.data.orderGoods;
					this.paidType = res.data.orderInfo.paidType;

					switch (self.paidType) {
						case 'B':
							return this.paidType = '계좌이체'
						case 'C':
							return this.paidType = '신용카드'
						case 'D':
							return this.paidType = '무통장입금'
						case 'K':
							return this.paidType = '카카오페이'
						case 'N':
							return this.paidType = '네이버페이'
						default:
							return this.paidType = '신용카드'   //기본으로 설정되어 있음
					}
				} else {
					console.log(this.$route.query.oid)
					this.swalUtils.gritter("Error", res.msg, "error")
							.then(() => {
								location.href = document.referrer
							})
				}
			});
		},

		doInicisCancel () {
			var self = this;
			this.swalUtils.fire("주문 취소하시겠습니까?", "회원님의 상품 주문이 모두 취소됩니다. 취소하시겠습니까? ", "error", true)
					.then((result) => {
						if ( result.isConfirmed ) {
							this.$eventBus.$emit("startProgress")
							this.axiosCaller.get(this, this.APIs.SHOP_PG + "/oidCancel", this.params, (res) => {

								this.$eventBus.$emit("doneProgress")
								const result = res.data;
								console.log("result", result)

								if (result.status === "ok") {
									if(result.resultData.resultCode==='00'){
										self.swalUtils.gritter("주문취소", "취소되었습니다", "success", 2000 )
												.then(() => {
													location.href = document.referrer
												})
									}else{
										self.swalUtils.gritter("code:" + result.resultData.resultCode, result.resultData.resultMsg, "warning", 2000 )
												.then(() => {
													location.href = document.referrer
												})
									}
								} else {
									console.log(this.$route.query.oid)
									self.swalUtils.gritter("Error", res.msg, "error")
											.then(() => {
												location.href = document.referrer
											})
								}

							});

						}
					})

		},

		doReqCancel () {

			var self = this;
			this.swalUtils.fire("주문 취소요청 하시겠습니까?", "상품이 발송되었으면 거절될 수 있으며, 취소 승인시 회원님의 상품 주문이 모두 취소됩니다. ", "error", true)
					.then((result) => {
						if ( result.isConfirmed ) {

							self.params.reqStat = 65;

							this.$eventBus.$emit("startProgress")
							this.axiosCaller.get(this, this.APIs.SHOP_PG + "/changeReqStat", this.params, (res) => {

								this.$eventBus.$emit("doneProgress")
								const result = res.data;
								console.log("result", result)

								if (result.status === "ok") {
									self.swalUtils.gritter("주문취소", "취소되었습니다", "success", 2000 )
											.then(() => {
												location.href = document.referrer
											})
								} else {
									console.log(this.$route.query.oid)
									self.swalUtils.gritter("Error", res.msg, "error")
											.then(() => {
												location.href = document.referrer
											})
								}

							});

						}
					})

		},

		goPaymentList () {
			history.back();
		},
	}
}
</script>

<style scoped>
	#cancelBtn, #cancelReqBtn {
		background-color: var(--secondary);
		color: #fff;
		margin-right: 7px;
	}

	@media (max-width: 767px) {
		#cancelBtn, #cancelReqBtn {
			background-color: var(--secondary);
			color: #fff;
			margin-bottom: 5px;
		}
	}
</style>
